export default "__VITE_ASSET__BXppnf2p__"